import { useEffect, message, useDispatch, useSelector, useState, useNavigate, Locale, toast, useParams } from '../../libraries';
import { handleErrorResponse, handleSuccessResponse, bookNow, getCashbackPerCheckout, dataForUniqueId, referralCodeVerification } from '../../services';
import { isCheckoutAddressValidation, isRequired, isRequiredCheckbox1, isRequiredRadioButton, isValidPhoneNumber } from '../../vendor/pages/Validation/Validation';
import { CustomerRoutes } from '../../routes/index';
import { getGeoAddress, getLatLngByAddress, decryptData, getDefaultCountryCode } from '../../customHooks/index';
import { fetchUserReferralsInformation } from '../../redux/index';
import { isValidName } from '../../common/validation/fieldRegex';

const BookNowPaymentLogic = () => {
  const navigate = useNavigate();
  const { t } = Locale();
  let initialValue = {
    fName: '',
    lName: '',
    email: '',
    dialCode: '',
    phone_number: '',
    paymentType: '',
    termAndConditon: false,
    checkbox: '',
    address: '',
    latitude: '',
    longitude: '',
    landmark: '',
  };
  const [err, setErr] = useState({});
  const [discountPrice, setDiscountPrice] = useState();
  const [discountCashback, setDiscountCashback] = useState();
  const [suraCashback, setSuraCashback] = useState();
  const [referralCode, setReferralCode] = useState();
  const [buttonDisable, setButtonDisable] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [apiCalculationData, setApiCalculationData] = useState();
  const [userInfo, setUserInfo] = useState();
  const [serviceDetails, setServiceDetails] = useState();
  const { unique_id } = useParams();
  const [serviceId, setServiceId] = useState();
  const [formValue, setFormValue] = useState(initialValue);
  const [isInvalidUrl, setInvalidUrl] = useState(false);
  const [calendarFormValue, setCalendarFormValue] = useState({})
  const [showModal, setShowModal] = useState(false)
  const [isPickedOrSelectLocation, setIsPickedOrSelectLocation] = useState(false);
  let data;
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchData = async () => {
      await dispatch(fetchUserReferralsInformation());
    };
    fetchData();
  }, [dispatch]);

  const userCashBackDetails = useSelector(
    (state) => state?.userCashBackDetails?.userCashBackDetails
  );

  useEffect(() => {
    const fetchData = async () => {
      if (unique_id) {
        try {
          let tempData = await calculationTotalData();
          setApiCalculationData(tempData);
        } catch (error) {
          handleErrorResponse(error);
        }
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (formValue.address) {
      let err = handleChangeValidation('address', formValue.address);
      setErr(err)
    }
  }, [isPickedOrSelectLocation])

  useEffect(() => { }, [discountPrice]);

  useEffect(() => {
    const getCashback = async () => {
      try {
        const response = await getCashbackPerCheckout();
        setSuraCashback(response.data.cashback_amount);
        return response;
      } catch (err) {
      }
    };
    getCashback();
  }, []);

  const handleClosePermissionModal = () => {
    setShowModal(false);
  }

  useEffect(() => {
    if (userInfo && Object.keys(userInfo).length > 0) {
      let phone_number =
        userInfo?.phone_number &&
        userInfo?.phone_number.split(' ')[1].toString();
      let tempCountryCode =
        userInfo?.phone_number &&
        userInfo?.phone_number.split(' ')[0].toString();
      setFormValue((prevFormValue) => ({
        ...prevFormValue,
        phone_number: phone_number,
        email: userInfo?.email,
        fName: userInfo?.first_name,
        lName: userInfo?.last_name,
        dialCode: tempCountryCode ? tempCountryCode : getDefaultCountryCode(),
      }));
    }
  }, [userInfo]);

  const calculationTotalData = async () => {
    try {
      let response = await dataForUniqueId(unique_id);
      if (response?.data?.product_detail) {
        setServiceDetails(response?.data?.product_detail?.booking_services);
        setUserInfo(response?.data?.product_detail?.address);
        getDecryptDataFun(response?.data?.url_payload, response?.data?.product_detail?.booking_services)
      }
      else {
        setInvalidUrl(true)
      }
      return response?.data?.product_detail?.booking;
    } catch (err) {
      setInvalidUrl(true)
      throw err;
    }
  };

  const getDecryptDataFun = (encryptData, booking_services) => {
    const decryptedData = decryptData(encryptData);
    setServiceId(decryptedData?.serviceId)
    setCalendarFormValue((prev) => ({
      ...prev,
      [decryptedData?.serviceId]: {
        booking_date: decryptedData?.booking_date,
        booking_time: decryptedData?.booking_time,
        atServiceLocation: decryptedData?.selectedLocation,
      }
    }))
    booking_services?.map((obj) => {
      setCalendarFormValue((prev) => ({
        ...prev,
        [decryptedData?.serviceId]: {
          ...prev[decryptedData?.serviceId],
          branch: {
            branch_id: obj?.branch_details?.id,
            branch_name: obj?.branch_details?.name
          },
        }
      }));
    })
  }

  const handleChange = (value) => {
    if (value?.target && value?.target?.name === 'termAndConditon') {
      setFormValue((prevFormValue) => ({
        ...prevFormValue,
        termAndConditon: value?.target?.value ? true : false,
      }));
      let err = handleChangeValidation('termAndConditon', value?.target?.value ? true : false);
      setErr(err)
    } else {
      setFormValue((prevFormValue) => ({
        ...prevFormValue,
        paymentType: value,
      }));
      let err = handleChangeValidation('paymentType', value);
      setErr(err)
    }
  };

  const handleSearch = async (e) => {
    try {
      setReferralCode(e);
      let err = {};
      if (!e) {
        err.refralCode = `${t('payment.refralCodeErr')}`;
        setErr(err);
      }
      if (Object.keys(err).length === 0) {
        err = {};
        setErr(err);
        const response = await referralCodeVerification(e);
        handleSuccessResponse(response, response.data.message);
      }
    } catch (err) {
      handleErrorResponse(err);
    }
  };

  const CashbackDiscount = async (e) => {
    if (e.target.checked) {
      try {
        const response = await getCashbackPerCheckout();
        setDiscountCashback(response.data.cashback_amount);
        return response;
      } catch (err) {
      }
    }
  };

  const onCheckUserCashback = async (e) => {
    try {
      const response = await CashbackDiscount(e);
      setDiscountPrice(parseInt(discountPrice) + parseInt(suraCashback));
      if (!response?.data?.message) {
        if (e.target.checked) {
          setDiscountPrice(
            apiCalculationData?.total_paid_amount -
            response.data.cashback_amount,
          );
        } else {
          setDiscountPrice(discountPrice + response?.data?.cashback_amount);
        }
      } else {
        message.error(response.data.message);
      }
    } catch (err) {
      handleErrorResponse(err);
    }
  };

  const validation = (formValue) => {
    let checkErr = {};
    checkErr = isRequiredCheckbox1(
      formValue.termAndConditon,
      { ...checkErr },
      'termAndConditon',
      t,
    );
    checkErr = isRequiredRadioButton(
      formValue.paymentType,
      { ...checkErr },
      'paymentType',
      t,
    );
    if (formValue.address) {
      checkErr = isCheckoutAddressValidation(
        isPickedOrSelectLocation,
        { ...checkErr },
        'address',
        t,
      );
    } else {
      checkErr = isRequired(
        isPickedOrSelectLocation,
        { ...checkErr },
        'address',
        `${t('field.address')}`,
        t,
      );
    }

    checkErr = isRequired(
      formValue.landmark,
      { ...checkErr },
      'landmark',
      `${t('field.flatNo')}`,
      t,
    );


    checkErr = isValidPhoneNumber(
      formValue.phone_number,
      { ...checkErr },
      'phoneNumber',
      `${t('field.phoneNumber')}`,
      '',
      t,
    );
    checkErr = isValidName(formValue?.fName, { ...checkErr }, 'fName', t('field.fname'), t);
    checkErr = isValidName(formValue?.lName, { ...checkErr }, 'lName', t('field.lName'), t)

    return checkErr;
  };

  const onChange = (name, value, countryData = null) => {
    setFormValue({ ...formValue, [name]: value });
  };
  const handleSubmit = async (
    formValue,
    total_amount,
    serviceId,
  ) => {


    let err = {};
    err = validation(formValue);
    setErr(err);
    if (!Object.keys(err).length > 0) {
      setIsLoading(true);
      setButtonDisable(true);
      const payment_type = formValue.paymentType;
      let service_id = serviceId;
      let booking_date = calendarFormValue?.[service_id]?.booking_date;
      let booking_time = calendarFormValue?.[service_id]?.booking_time;
      let delivery_type = calendarFormValue?.[service_id]?.atServiceLocation;
      let branch_id = calendarFormValue?.[service_id]?.branch?.branch_id;
      const bookingDetails = [
        {
          service_id,
          booking_date,
          booking_time,
          delivery_type,
          branch_id
        },
      ];

      data = {
        first_name: formValue?.fName,
        last_name: formValue?.lName,
        payment_type: payment_type,
        referral_code: referralCode,
        contact_number: formValue.dialCode + ' ' + formValue.phone_number,
        make_as_permanent_address: formValue.checkbox,
        total_amount: total_amount,
        applied_cashback: discountCashback ? true : false,
        booking_service_details: bookingDetails,
        address: formValue.address,
        landmark: formValue?.landmark,
        latitude: formValue?.latitude,
        longitude: formValue?.longitude,

      };
      try {
        let response = await bookNow(data);
        if (data?.payment_type === "online") {
          const checkoutUrl = response?.data?.checkout_url;
          if (checkoutUrl && checkoutUrl !== 'null') {
            window.location.href = checkoutUrl;
            setIsLoading(false);
          } else {
            setIsLoading(false);
            setButtonDisable(false);
            toast.error(t('userBooking.paymentUrlNullError'));
          }
        }

        else {
          localStorage.setItem('isSection', 'isBooking');
          setIsLoading(false);
          handleSuccessResponse(response, response?.data?.message)
          navigate(`${CustomerRoutes.user}${CustomerRoutes.bookings}`);
        }

      } catch (err) {
        setButtonDisable(false);
        setIsLoading(false);
        handleErrorResponse(err);
      }
    }
  };

  const handleClickUseMyLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { latitude, longitude } = position.coords;
          try {
            let response = await getGeoAddress(latitude, longitude);
            let err = handleChangeValidation('address', response.address);
            setErr(err)
            setFormValue((prev) => ({
              ...prev,
              address: response.address,
              // landmark: response.landmark,
              latitude: latitude,
              longitude: longitude,
            }));
            setIsPickedOrSelectLocation(true);
          } catch (error) {
            console.error('Error getting geocode response:', error);
          }
        },
        (error) => {
          if (error.code === error.PERMISSION_DENIED) {
            setShowModal(true)
          }
        },
      );
    } else {
      console.error('Geolocation is not supported by this browser.');
    }
  };

  const handleChangePlace = async (e, onSelect) => {
    let longitude;
    let latitude;
    let address;
    if (onSelect) {
      latitude = e?.geometry?.location?.lat();
      longitude = e?.geometry?.location?.lng();
      address = e.formatted_address
      setFormValue((prev) => ({
        ...prev,
        address: e.formatted_address,
        latitude: latitude,
        longitude: longitude,
      }));
      setIsPickedOrSelectLocation(true)
    } else {
      setIsPickedOrSelectLocation(false)
      address = e.target.value
      setFormValue((prev) => ({
        ...prev,
        address: e.target.value,
      }));
    }
    let err = handleChangeValidation('address', address);
    setErr(err)
  };

  const handleNevigateTermCondition = (event) => {
    event.preventDefault();
    window.open(CustomerRoutes.termCondition, '_blank');
  };

  const handleCountryCode = (e) => {
    setFormValue((prevValues) => ({
      ...prevValues,
      dialCode: e.dialCode,
    }));

  }

  const handlePhoneNumberChange = (e) => {
    setFormValue((prevValues) => ({
      ...prevValues,
      phone_number: e.nationalNumber,
      dialCode: e.dialCode,
    }));
    const errorLogs = handleChangeValidation('phoneNumber', e.nationalNumber);
    setErr(errorLogs);
  }

  const handleSavedAddress = (addressObj, setActiveKey) => {
    setFormValue((prev) => ({
      ...prev,
      address: addressObj?.address,
      latitude: addressObj?.latitude,
      longitude: addressObj?.longitude,
    }))
    setActiveKey(null);
  }

  const handleChangeDetailsSection = (e) => {
    const { name, value } = e.target;
    setFormValue((prev) => ({
      ...prev,
      [name]: value
    }))
    let err = handleChangeValidation(name, value);
    setErr(err)


  }

  const handleChangeValidation = (name, value) => {
    let error = { ...err };
    if (error.hasOwnProperty(name)) {
      delete error?.[name];
    }
    if (name === 'phoneNumber') {
      error = isValidPhoneNumber(
        value,
        { ...error },
        'phoneNumber',
        `${t('field.phoneNumber')}`,
        '',
        t,
      );
    }
    if (name === 'fName' || name === 'lName') {
      const fieldName = name === 'fName' ? t('field.fname') : t('field.lName');
      error = isValidName(value, error, name, fieldName, t);
    }
    return error;
  }


  return {
    handleNevigateTermCondition,
    isLoading,
    formValue,
    handleSubmit,
    handleChange,
    err,
    handleSearch,
    onCheckUserCashback,
    discountPrice,
    onChange,
    buttonDisable,
    suraCashback,
    apiCalculationData,
    serviceDetails,
    handleClickUseMyLocation,
    handleChangePlace,
    userCashBackDetails,
    serviceId,
    isInvalidUrl,
    showModal,
    handleClosePermissionModal,
    calendarFormValue,
    setCalendarFormValue,
    setApiCalculationData,
    handlePhoneNumberChange,
    handleCountryCode,
    handleSavedAddress,
    handleChangeDetailsSection,
    setFormValue,
    setIsPickedOrSelectLocation,
    setErr,
  };
};
export default BookNowPaymentLogic;